export default __webpack_public_path__ + "static/media/canvasBgMobile.05b1e663.png";